/// <reference path="../../node_modules/@types/jquery/index.d.ts" />

declare var endTime: any;
declare const registerUrl: string;
let dealerInterval;

$(document).ready(function () {
    $('#player').hide();
    $('#play_vid').click(function () {
        $('#player').show();
        $('#play_vid').hide();
    });

    $("#audio-player-btn").click(function () {
        if ($(".audio-player").hasClass('hidden')) {
            $(".audio-player").removeClass('hidden');
            ($(".audio-player audio")[0] as any).play();
        } else {
            ($(".audio-player audio")[0] as any).load();
            $(".audio-player").addClass('hidden');
        }
    });

    $(".we_also_offer li").click(function (evt) {
        const link = $(this).find('a').attr('href');
        window.location.href = link;
    });

    $(".we_also_offer li a").click(function (evt) {
        evt.stopPropagation();
    });

    $('.img-defer').each(function () {
        var $img = $(this);
        var src = $img.data("src");
        if (src) {
            $img.attr("src", src);
        }
    });

    $(document).scroll(function () {
        var y = $(this).scrollTop();
        if (y > 900) {
            $('.bottomMenu').fadeIn();
        } else {
            $('.bottomMenu').fadeOut();
        }
    });

    $('.bottomMenu .button').click(function () {
        var selstate = $('.bottomMenu select.statedropdown').val();
        if (selstate && !$(this).parent().hasClass('insurance-state-selector')) {
            window.location.href = "/states/default2.aspx?statecode=" + selstate;
        }
    });

    $(".insurance-state-selector select").change(function (evt: any) {
        window.location.href = registerUrl + '/course-selection/?st=' + evt.target.value + '&insurance=true';
    });

    var $dealPanel = $('.special-deal');


    function setDealNumbers() {
        if (typeof endTime === 'undefined') {
            return;
        }
        var diff = endTime.getTime() - Date.now();
        if (diff <= 0) {
            $dealPanel.addClass('hidden');
            clearInterval(dealerInterval);
        } else {
            $dealPanel.removeClass('hidden');
            var days = Math.floor(diff / (1000 * 60 * 60 * 24));
            $('.sales-time.number-days').text(days);

            diff -= 1000 * 60 * 60 * 24 * days;
            var hours = Math.floor(diff / (1000 * 60 * 60));
            $('.sales-time.number-hours').text(hours);

            diff -= 1000 * 60 * 60 * hours;
            var minutes = Math.floor(diff / (1000 * 60));
            $('.sales-time.number-minutes').text(minutes);

            diff -= 1000 * 60 * minutes;
            var seconds = Math.floor(diff / (1000));
            $('.sales-time.number-seconds').text(seconds);
        }
    }

    if (typeof endTime != 'undefined') {
        setDealNumbers();

        dealerInterval = setInterval(function () {
            setDealNumbers();
        }, 1000);
    }
});

window.addEventListener('unload', function () {
    if (dealerInterval) {
        clearInterval(dealerInterval);
    }
});
